var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaperClip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9D9D9D",
  d: "M9.364 21h-4.74L3 19.376v-4.74L14.382 3.254h2.194l2.473 2.473V7.92l-9.185 9.185-1.76.586-1.796-1.796.586-1.76L11.66 9.37l.848.849-4.566 4.567-.263.786.749.749.786-.263 8.634-8.633v-1.2l-1.77-1.77h-1.2L4.2 15.134v3.745l.922.921h3.746l9.582-9.582.848.848z"
})));
export default SvgPaperClip;